import { IBaseAlertProps } from "@components/alert/Alert.types";
import {
    EntitySetName,
    IPrYearOperationEntity,
    IPrYearOperationSectionEntity,
    PrYearOperationEntity
} from "@odata/GeneratedEntityTypes";
import { PrYearOperationSectionTypeCode } from "@odata/GeneratedEnums";
import { OData } from "@odata/OData";
import AnnualTaxStatement from "@pages/payroll/payrollYearOperations/screens/AnnualTaxStatement";
import PayrollSheetsProcessing from "@pages/payroll/payrollYearOperations/screens/PayrollSheetsProcessing";
import TaxpayerDeclaration from "@pages/payroll/payrollYearOperations/screens/TaxpayerDeclaration";
import { logger } from "@utils/log";
import { FunctionComponent } from "react";

import { REST_API_URL } from "../../../constants";
import { FormStorage } from "../../../views/formView/FormStorage";

export async function getPayrollYearOperations(oData: OData): Promise<IPrYearOperationEntity[]> {
    try {
        const response = await oData.getEntitySetWrapper(EntitySetName.PrYearOperations)
                .query()
                .select(PrYearOperationEntity.Id, PrYearOperationEntity.Year)
                .orderBy(PrYearOperationEntity.Year)
                .fetchData<IPrYearOperationEntity[]>();
        return response?.value ?? [];
    } catch (e) {
        logger.error("Error while fetching PrYearOperations", e);
        return [];
    }
}

export const SortedPRYearOperationSections = [
    PrYearOperationSectionTypeCode.PayrollSheetsProcessing,
    PrYearOperationSectionTypeCode.AnnualTaxStatement,
    PrYearOperationSectionTypeCode.TaxpayerDeclaration,
    // PrYearOperationSectionTypeCode.AdvancedAndWithholdingTaxSettlement,
    // PrYearOperationSectionTypeCode.MandatoryShareOfDisabledPeopleDeclaration,
    // PrYearOperationSectionTypeCode.StatisticalReports,
    // PrYearOperationSectionTypeCode.ELDP,
];

export interface ISectionProps {
    task: IPrYearOperationSectionEntity;
    onCheck: (checked: boolean) => Promise<IBaseAlertProps>;
    storage: FormStorage;
    year: string;
}

export const getFormForSectionType = (sectionType: PrYearOperationSectionTypeCode): FunctionComponent<ISectionProps> => {
    switch (sectionType) {
        case PrYearOperationSectionTypeCode.PayrollSheetsProcessing:
            return PayrollSheetsProcessing;
        case PrYearOperationSectionTypeCode.TaxpayerDeclaration:
            return TaxpayerDeclaration;
        case PrYearOperationSectionTypeCode.AnnualTaxStatement:
            return AnnualTaxStatement;
        // case PrYearOperationSectionTypeCode.AdvancedAndWithholdingTaxSettlement:
        //     return AdvancedAndWithholdingTaxSettlement;
        // case PrYearOperationSectionTypeCode.StatisticalReports:
        //     return StatisticalReports;
        // case PrYearOperationSectionTypeCode.MandatoryShareOfDisabledPeopleDeclaration:
        //     return MandatoryShareOfDisabledPeopleDeclaration;
        // case PrYearOperationSectionTypeCode.ELDP:
        //     return Eldp;
    }
};

const PAYROLL_YEAR_OPERATION_API_URL = `${REST_API_URL}/PrYearOperations`;
export const CREATE_YEAR_OPERATION_URL = `${PAYROLL_YEAR_OPERATION_API_URL}/{year}/CreatePrYearOperation`;
export const GENERATE_PAYROLL_SHEETS = `${PAYROLL_YEAR_OPERATION_API_URL}/{year}/GeneratePayrollSheets`;
export const GENERATE_ADVANCED_TAX_RETURN_XML = `${PAYROLL_YEAR_OPERATION_API_URL}/{year}/GenerateAdvancedTaxReturnXml`;
export const GENERATE_WITHHOLDING_TAX_RETURN_XML = `${PAYROLL_YEAR_OPERATION_API_URL}/{year}/GenerateWithholdingTaxReturnXml`;
export const GENERATE_ADVANCED_TAX_RETURN_URL = `${PAYROLL_YEAR_OPERATION_API_URL}/{year}/GenerateAdvancedTaxReturnEpoUrl`;
export const GENERATE_WITHHOLDING_TAX_RETURN_URL = `${PAYROLL_YEAR_OPERATION_API_URL}/{year}/GenerateWithholdingTaxReturnUrl`;
export const GET_DISABLED_SHARE_URL = `${PAYROLL_YEAR_OPERATION_API_URL}/{year}/DisabledShare`;
export const ARCHIVE_PAYROLL_SHEETS_URL = `${PAYROLL_YEAR_OPERATION_API_URL}/{year}/DownloadAllPayrollSheets`;